// extracted by mini-css-extract-plugin
export default {"button":"Button__button___ixy9B"};